import React from "react";
import {
  Select,
  Row,
  Col,
  Button,
  Space,
  DatePicker,
  Dropdown,
  Modal,
  Table, Checkbox, Tooltip, Image
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import { DownOutlined } from "@ant-design/icons";
import ListTable from "./ListTable";
import CompanyAutocomplete from "./CompanyAutocomplete";
import withRouter from "../withRouter";
import VehicleStore from "../store/VehicleStore";

import dayjs from "dayjs";
import { decode as base64_decode } from "base-64";
import Cookies from "js-cookie";
import DeviceGroupsForVehicles from "./DeviceGroupsForVehicles";
import DriverLoginReportStore from "../store/DriverLoginReportStore";
import DriverLogReportStore from "../store/DriverLogReportStore";
import PDF from "../assets/images/NewDesign/PDF.svg";
import Excel from "../assets/images/NewDesign/Excel.svg";
import XML from "../assets/images/NewDesign/XML.svg";
import CSV from "../assets/images/NewDesign/CSV.svg";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import downloadIcon from "../assets/images/NewDesign/Download.svg";
const { RangePicker } = DatePicker;

const { Option } = Select;

let widthAdderFunc = (arr) => {
  let array = arr;
  array.map((val) => {
    if (val.title?.length > 24) {
      val.width = 250;
    } else if (val.title?.length > 15) {
      val.width = 200;
    } else if (val.title?.length > 12) {
      val.width = 150;
    } else if (val.title?.length > 8) {
      val.width = 125;
    } else {
      val.width = 110;
    }
  });

  return arr;
};
class DriverLogReport extends React.Component {
  constructor(props, context) {
    super(props);
    console.log("props *******************", props)
    this.handleTableChange = this.handleTableChange.bind(this);
    // this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.vehicleStore = new VehicleStore();
    this.driverLogReportStore = new DriverLogReportStore(this);
    this.driverLoginStore = new DriverLoginReportStore(this);
    this.ExportOption = [
      {
        label: (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
          >
            {" "}
            <Image
              style={{ height: "18px", width: "18px", borderRadius: "0px" }}
              src={Excel}
            ></Image>
            {context.translate("_EXPORT_AS_EXCEL_")}
          </div>
        ),
        key: "excel",
      },
    ];
    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      selectedVehicles: [],
      selectedDrivers: [],
      selectAllVehicles: false,
      selectAllDrivers: false,
      showMonthPopup: false,
      filterby: "",
      data: "",
      companyId: "",
      fromDate: dayjs().format("YYYY-MM-DD 00:00:00"),
      toDate: dayjs().format("YYYY-MM-DD HH:mm:ss"),
      Notcompany: false,
      Notasset: false,
      NotDriver: false,
      expandedRowKeys: [],
      loadedInvoiceData: {},
      selectAllStatus: false,
      status: [],
      innerGridData: [],
      hasInvoice: false,
      filterValue: "",
      filterNotSelected: false,

      selectedColumns: widthAdderFunc([
        {
          title: context.translate("_DRIVER_NAME_"),
          dataIndex: "driverName",
          key: "driverName",
          width: "15%",
        },
        {
          title: context.translate("_TOTAL_NO_OF_TRIPS_"),
          dataIndex: "totalTrips",
          key: "totalTrips",
          width: "15%",
        },

        {
          title: context.translate(
            "_FLEET_CREATEROUTE_ROUTEADD_TOTALDISTANCE_"
          ),
          dataIndex: "odometer",
          key: "odometer",
          width: "15%",
        },

        {
          title: context.translate("_TOTAL_DISTANCE_FARE_"),
          dataIndex: "totalTripDistanceFare",
          key: "totalTripDistanceFare",
          width: "15%",
        },

        {
          title: context.translate("_TOTAL_WAITING_TIME_FARE_"),
          dataIndex: "totalTripWaitingTimeFare",
          key: "totalTripWaitingTimeFare",

          width: "15%",
        },

        {
          title: context.translate("_TOTAL_VAT_"),
          dataIndex: "totalTaxAmount",
          key: "totalTaxAmount",
          width: "15%",
        },
        {
          title: context.translate("_TOTAL_FARE_"),
          dataIndex: "totalFare",
          key: "totalFare",
          width: "15%",
        },
      ]),
    };
    this.menuProps = {
      items: this.ExportOption,
      onClick: (val) => {
        let result = [];

        if (true) {
          this.state.selectedColumns.map((obj) => result.push(obj.dataIndex));

          var getData = {
            userId: JSON.parse(base64_decode(Cookies.get("data"))).userId,
            isadmin: JSON.parse(base64_decode(Cookies.get("data"))).isadmin,
            companyId: this.state.companyId,
            vehicleId: this.state.selectedVehicles,
            filterBy: this.state.filterby,
            driverId: this.state.selectedDrivers,
            fromDate: this.state.fromDate,
            toDate: this.state.toDate,
            colList: result.toString(),
            language: null,
          };
          if (val.key == "excel") {
            this.driverLogReportStore.exportExcel(getData);
          }
          if (val.key == "pdf") {
            this.driverLogReportStore.exportpdf(getData);
          }
        }
      },
    };
    this.newColumns = [...this.state.selectedColumns];
  }

  async componentDidMount() {
    console.log("driver log report")
    this.setState({ pageSize: 50 });

    if (Number(this.props.getUserData().isadmin) !== -1) {
      let companyId = this.props.getUserData().userCompanyId;

      this.setState({ companyId: companyId });
      this.handleChange({ value: companyId });
    }
    await this.setState({ column: this.state.selectedColumns });
  }

  async handleChange(comp) {
    await this.setState({ Notcompany: false });
    await this.setState({ companyId: comp?.value });
    await this.setState({
      selectedVehicles: [],
      selectAllVehicles: false,
      selectedDrivers: [],
      selectAllDrivers: false,
    });

    await this.vehicleStore.getDeliveryVehicles(comp?.value);

    await this.driverLoginStore.getDriversByCompanyId({
      companyId: comp?.value,
    });

    await this.setState({ loadData: 1 });
  }

  async handleTableChange(pagination, filters, sorter) {
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    // this.handleSearch();
    await this.showData();
  }

  addMonths = (date, months) => {
    var indx = dayjs().month() + -6;

    return dayjs().month(indx);
  };
  checkFromDate(dates) {
    var fromDate = dates;
    var pdate = this.addMonths();
    if (pdate > fromDate) {
      this.setState({ showMonthPopup: true });
      return false;
    } else {
      return true;
    }
  }

  onDateTimeChange = (dates) => {
    if (dates) {
      const format = "YYYY-MM-DD HH:mm:ss";
      this.setState({
        fromdateStdTime: dates[0],
        fromDate: dates[0].format(format),
        toDate: dates[1].format(format),
      });
    }
  };

  showData = async () => {
    if (!this.state.companyId) {
      this.setState({ Notcompany: true });
    } else {
      this.setState({ Notcompany: false });
    }

    if (this.state.selectedDrivers.length === 0) {
      this.setState({ NotDriver: true });
    } else {
      this.setState({ NotDriver: false });
    }

    if (this.state.companyId && this.state.selectedDrivers.length > 0) {
      this.setState({ Notcompany: false, NotDriver: false });
      if (this.checkFromDate(this.state.fromdateStdTime)) {
        await this.driverLogReportStore.loadData({
          offset: (this.state.currentPage - 1) * this.state.pageSize,
          limit: this.state.pageSize,
          companyId: this.state.companyId,
          driverId: this.state.selectedDrivers,
          fromDate: this.state.fromDate,
          toDate: this.state.toDate,
          pageNo: this.state.currentPage,
        });
        await this.setState({ loadData: 1 });
      }
    }
  };

  expandedRowRender = (id) => {
    const columns = [
      {
        title: this.context.translate("_VEHICLE_NO_"),
        dataIndex: "vehicleNo",
        key: "vehicleNo",
        width: "10%",
      },
      {
        title: this.context.translate("_NO_OF_PASSENGERS_"),
        dataIndex: "noOfPassenger",
        key: "noOfPassenger",
        width: "10%",
      },
      {
        title: this.context.translate("_PICKUP_TIME_"),
        dataIndex: "tripStartTime",
        key: "tripStartTime",
        width: "10%",
      },
      {
        title: this.context.translate("_PICKUP_LOCATION_"),
        dataIndex: "pickupAddress",
        key: "pickupAddress",
        width: "10%",
      },
      {
        title: this.context.translate("_DROP_TIME_"),
        dataIndex: "tripEndTime",
        key: "tripEndTime",
        width: "10%",
      },
      {
        title: this.context.translate("_DROP_LOCATION_"),
        dataIndex: "dropAddress",
        key: "dropAddress",
        width: "10%",
      },
      {
        title: this.context.translate("_FLEET_DASHBORD_SETTING_ODOMETER_"),
        dataIndex: "tripdistance",
        key: "tripdistance",
        width: "10%",
      },
      {
        title: this.context.translate("_WAITING_TIME_"),
        dataIndex: "waitingTime",
        key: "waitingTime",
        width: "12%",
        render: (value) => this.formatDuration(value),
      },
      {
        title: this.context.translate("_TRIP_DURATION_"),
        dataIndex: "duration",
        key: "duration",
        width: "12%",
        render: (value) => this.formatDuration(value),
      },
      {
        title: this.context.translate("_ORDER_CHANNEL_"),
        dataIndex: "orderChannelId",
        key: "orderChannelId",
        width: "10%",
        render: (value, record) => {
          switch (parseInt(record.orderChannelId, 10)) {
            case 1:
              return "App";
            case 2:
              return "Local";
            case 3:
              return "Call Center";
            default:
              return "App";
          }
        },
      },

      {
        title: this.context.translate("_PAYMENT_TYPE_"),
        dataIndex: "paymentMethod",
        key: "paymentMethod",
        width: "10%",
        render: (value, record) => {
          switch (record.paymentMethod) {
            case 1:
              return "Cash";
            case 2:
              return "Card";
            case 3:
              return "QRIS";
            default:
              return "Cash";
          }
        },
      },
      {
        title: this.context.translate("_FARE_TYPE_"),
        dataIndex: "selectedFareType",
        key: "selectedFareType",
        width: "10%",
        render: (value, record) => {
          switch (record.selectedFareType) {
            case 1:
              return "Fixed";
            case 2:
              return "Estimated";
            default:
              return "Estimated";
          }
        },
      },
      {
        title: this.context.translate("_BASIC_FARE_"),
        dataIndex: "basicFare",
        key: "basicFare",
        width: "12%",
      },

      {
        title: this.context.translate("_DISTANCE_FARE_"),
        dataIndex: "tripDistanceFare",
        key: "tripDistanceFare",
        width: "12%",
      },
      {
        title: this.context.translate("_WAITING_FARE_"),
        dataIndex: "tripWaitingTimeFare",
        key: "tripWaitingTimeFare",
        width: "12%",
      },

      {
        title: this.context.translate("_VAT_"),
        dataIndex: "taxAmount",
        key: "taxAmount",
        width: "12%",
      },
      {
        title: this.context.translate("_TOLL_"),
        dataIndex: "toll",
        key: "toll",
        width: "12%",
      },
      {
        title: this.context.translate(
          "_FLEET_DASHBORD_NEWPOI_TYPEDDL_AIRPORT_"
        ),
        dataIndex: "airport",
        key: "airport",
        width: "12%",
      },
      {
        title: this.context.translate("_PARKING_"),
        dataIndex: "parking",
        key: "parking",
        width: "12%",
      },
      {
        title: this.context.translate("_TOTAL_FARE_"),
        dataIndex: "totalFare",
        key: "totalFare",
        width: "12%",
      },
    ];

    return (
      <div className="innerGridTbl">
        <Table
          bordered
          size="small"
          style={{ padding: "20px 20px 20px 10px" }}
          columns={columns}
          // scroll={{ x: 50 }}
          dataSource={this.driverLogReportStore.tripData}
          pagination={false}
        />
      </div>
    );
  };

  onExpand = async (expanded, record) => {
    const expandedRowKeys = expanded ? [record.driverId] : [];
    this.setState({ expandedRowKeys });

    if (expanded) {
      await this.handleExpandRow(record);
    }
  };

  handleExpandRow = async (record) => {
    this.setState({ innerGridData: record });
    if (!this.state.loadedInvoiceData[record.driverId]) {
      await this.driverLogReportStore.loadDriverLogData({
        driverId: record.driverId,
        fromDate: this.state.fromDate,
        toDate: this.state.toDate,
        companyId: this.state.companyId,
      });
      this.setState((prevState) => ({
        loadedInvoiceData: {
          ...prevState.loadedInvoiceData,
          [record.startTime]: true,
        },
      }));
    }
  };

  formatDuration = (value) => {
    const d = Number(value);

    const h = Math.floor(d / 3600);
    const m = Math.floor((d % 3600) / 60);
    const s = Math.floor(d % 60);

    const hDisplay = h > 0 ? String(h).padStart(2, "0") + ":" : "00:";
    const mDisplay = m > 0 ? String(m).padStart(2, "0") + ":" : "00:";
    const sDisplay = s > 0 ? String(s).padStart(2, "0") : "00";

    return hDisplay + mDisplay + sDisplay;
  };
  handleCheckboxChange = async (column) => {
    console.log(column);
    if (this.state.selectedColumns.some((c) => c.key === column.key)) {
      const filtered = this.state.selectedColumns.filter(
        (c) => c.key !== column.key
      );
      console.log(filtered);
      await this.setState({
        selectedColumns: filtered,
      });
      await this.setState({ column: filtered });
      // await  this.updateVisibleColumns();
    } else {
      await this.setState({
        selectedColumns: [...this.state.selectedColumns, column],
        column: [...this.state.selectedColumns, column],
      });
      // await  this.updateVisibleColumns();
    }
  };
  refreshList = async () => {
    await this.setState({ loading: false, pageNo: 1, currentPage: 1 });
    await this.showData();
  };
  render() {
    return (
      <>
        {/* <div style={{ padding: 0 }}>
          <Row className="headerFixed">
            <Col span={12}>
              <div className="heading">
                {this.context.translate("_DRIVER_LOG_REPORT_")}
              </div>
            </Col>
            <Col
              span={12}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              <Space
                style={{
                  float:
                    this.context.locale.direction == "ltr" ? "right" : "left",
                }}
              >
                <Dropdown
                  menu={this.menuProps}
                  disabled={
                    this.driverLogReportStore?.driverLogData?.length > 0
                      ? false
                      : true
                  }
                >
                  <Button className="exportDropdown">
                    <Space>
                      {this.context.translate("_EXPORT_")}
                      <DownOutlined />
                    </Space>
                  </Button>
                </Dropdown>
              </Space>
            </Col>
          </Row>
        </div> */}
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={16}>
              <Space>
                <CompanyAutocomplete
                  className="searchInput"
                  onChange={this.handleChange}
                  allowClear={true}
                  style={{ width: 150 }}
                  status={this.state.Notcompany ? "error" : false}
                />
                {/* {this.props.getUserData().isadmin === 1 && (
                  <>
                    <DeviceGroupsForVehicles
                      vehicleStore={this.vehicleStore}
                      setLoadDta={() => this.setState({ loadData: 1 })}
                      resetVehicles={() =>
                        this.setState({
                          selectedVehicles: [],
                          selectAllVehicles: false,
                        })
                      }
                    />
                  </>
                )} */}

                <>
                  <Select
                    maxTagCount="responsive"
                    className="searchInput"
                    value={this.state.selectedDrivers}
                    onChange={(val) => {
                      this.setState({ selectedDrivers: val });
                    }}
                    style={{ width: 180 }}
                    showSearch
                    status={this.state.NotDriver ? "error" : false}
                    mode="multiple"
                    placeholder={this.context.translate(
                      "_FLEET_DRIVER_DRIVERLIST_DRIVERNAME_"
                    )}
                    filterOption={(inputValue, option) => {
                      if (option.children) {
                        return (
                          option.children
                            .toLowerCase()
                            .indexOf(inputValue.toLowerCase()) >= 0
                        );
                      }
                    }}
                  >
                    {this.driverLoginStore?.getDrivers?.map((val) => {
                      return (
                        <Option key={val.driverId} value={val.driverId}>
                          {val.name}
                        </Option>
                      );
                    })}
                  </Select>
                </>

                <RangePicker
                  className="searchInput"
                  placeholder={[
                    this.context.translate("_FROM_DATE_TIME_"),
                    this.context.translate("_TO_DATETIME_"),
                  ]}
                  format="DD-MM-YYYY hh:mmA"
                  style={{ width: 400, borderRadius: "25px" }}
                  onChange={(val) => {
                    this.onDateTimeChange(val);
                  }}
                  // disabledDate={(current) => {
                  //   return current && current > dayjs();
                  // }}
                  showTime={{
                    format: "h:mmA",
                    defaultValue: [dayjs().startOf("day"), dayjs()],
                  }}
                  defaultValue={[dayjs().startOf("day"), dayjs()]}
                />

                <Button type="primary" onClick={() => this.showData()}>
                  {this.context.translate("_FLEET_SHOW_BTN_")}
                </Button>

                <Button onClick={() => this.setState({ modalVisible: true })}>
                  {this.context.translate("_COLUMNS_")}
                </Button>
              </Space>
            </Col>
            <Col span={4}>
              <Space
                style={{
                  float:
                    this.context.locale.direction == "ltr" ? "right" : "left",
                }}
              ></Space>
            </Col>
            <Col
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
              span={4}
            >
              <Space>
                <Tooltip
                  title={this.context.translate("_REFRESH_")}
                  placement="bottom"
                >
                  <Image
                    style={{
                      height: 18,
                      marginInlineEnd: "20px",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    src={refreshIcon}
                    onClick={() => this.refreshList()}
                  ></Image>
                </Tooltip>
                <Button
                  className="downloadExcelButton"
                  disabled={
                    this.driverLogReportStore?.driverLogData?.length > 0
                      ? false
                      : true
                  }
                >
                  <Dropdown
                    overlayClassName="export-dropdown"
                    menu={this.menuProps}
                  >
                    <Image
                      style={{
                        height: 18,
                        alignItems: "center",
                        marginInlineEnd: "30px",
                      }}
                      src={downloadIcon}
                    ></Image>
                  </Dropdown>
                </Button>
              </Space>
            </Col>
          </Row>

          <ListTable
            rowKey="driverId"
            expandable={{
              expandedRowRender: this.expandedRowRender,
              onExpand: this.onExpand,
              expandedRowKeys: this.state.expandedRowKeys,
            }}
            currentPage={this.state.currentPage}
            pageSize={this.state.pageSize}
            total={this.driverLogReportStore?.total}
            columns={this.state.column}
            dataSource={this.driverLogReportStore?.driverLogData}
            loading={this.driverLogReportStore?.loading}
            onChange={this.handleTableChange}
          />
        </div>
        <Modal
          open={this.state.modalVisible}
          width={250}
          // title="Select Columns"
          title={this.context.translate("_SELECT_COLUMNS_")}
          onCancel={() => this.setState({ modalVisible: false })}
          onOk={() => {
            this.setState({ modalVisible: false });
          }}
          footer={null}
        >
          <div style={{ maxHeight: "400px", overflowY: "auto" }}>
            {console.log(this.newColumns, "Df")}
            {this.newColumns.map((column, v) => {
              return (
                <Row key={v}>
                  <Col>
                    <Checkbox
                      onChange={() => this.handleCheckboxChange(column)}
                      checked={this.state.selectedColumns.some(
                        (c) => c.key === column.key
                      )}
                    >
                      {column.title}
                    </Checkbox>
                  </Col>
                </Row>
              );
            })}
          </div>
        </Modal>
        <Modal
          width={350}
          className="alert-model"
          title={
            <div>
              {" "}
              <i
                style={{ color: "red", fontSize: "18px", marginRight: "5px" }}
                class="bi bi-exclamation-triangle"
              ></i>{" "}
              {this.context.translate("_FLEET_ALERT_")}
            </div>
          }
          open={this.state.showMonthPopup}
          onOk={() => this.setState({ showMonthPopup: false })}
          onCancel={() => this.setState({ showMonthPopup: false })}
          footer={false}
        >
          {this.context.translate("_REPORTS_PRIOR_CONTACT_ADMINISTRATOR_")}
        </Modal>
      </>
    );
  }
}
DriverLogReport.contextType = StoreContext;
export default observer(withRouter(DriverLogReport));
